export type DeviceConfiguration = {
  forceUpgradeLinks?: Record<string, string>;
  forceUpgrade?: {
    enabled: boolean;
    languageCode?: string;
    skippableInterval: number;
    brands: {
      blocked: Set<number>;
      forced: Set<number>;
      skippable: Set<number>;
    };
  };
  translationDictionaries: Record<string, string>;
};

export enum ForceUpgradeType {
  Blocked = 'blocked',
  Forced = 'forced',
  Skippable = 'skippable',
}

export type BlockedUpgrade = {
  type: ForceUpgradeType.Blocked;
};

export type ForcedUpgrade = {
  links?: Record<string, string>;
  type: ForceUpgradeType.Forced;
};

export type SkippableUpgrade = {
  links?: Record<string, string>;
  skippableInterval: number;
  type: ForceUpgradeType.Skippable;
};

export type ForceUpgradeConfiguration = BlockedUpgrade | ForcedUpgrade | SkippableUpgrade;
